import { Component, Input, OnInit } from '@angular/core';
import { Restricao, RestricaoOperador, Restricoes, MensagemService, ProgressoService } from 'maestro-ng';
import { FonteDados } from '../fonte-dados.model';
import { FonteDadosBandoDeDados } from './fonte-dados-banco-de-dados.model';
import { FonteDadosService } from '../fonte-dados.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DataSourceRouted } from '../../util/data-source-routed';

@Component({
  selector: 'app-fonte-dados-banco-de-dados',
  templateUrl: './fonte-dados-banco-de-dados.component.html',
  styleUrls: ['./fonte-dados-banco-de-dados.component.css'],
})
export class FonteDadosBandoDeDadosComponent implements OnInit {
  public ds: DataSourceRouted<FonteDadosBandoDeDados, number>;

  @Input()
  public fonteDados: FonteDados;

  public carregando: boolean;
  public atributo: string;
  public valor: any;

  constructor(
    private service: FonteDadosService,
    private mensagemService: MensagemService,
    private progressoService: ProgressoService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.ds = new DataSourceRouted<FonteDadosBandoDeDados, number>(
      'fonte-dados-banco-dados',
      (c) => this.service.recuperarListaAlteracoesBancoDeDados(this.fonteDados, c),
      this.mensagemService,
      this.progressoService,
      this.route,
      this.router,
      15,
      new Restricoes([
        new Restricao<number>({ atributo: 'id', operador: RestricaoOperador.EQUALS }),
        new Restricao<string>({ atributo: 'autor', operador: RestricaoOperador.CONTAINS }),
        new Restricao<string>({ atributo: 'arquivo', operador: RestricaoOperador.CONTAINS }),
        new Restricao<string>({ atributo: 'descricao', operador: RestricaoOperador.CONTAINS }),
      ])
    );
  }

  ngOnInit(): void {
    this.progressoService.modal();
  }
}
